import { EmployeeTimeoffPoliciesFromLeavesQuery } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { getMonthsOfYear } from 'modules/core/lib/dates'

import Month from './_Month'
import * as styles from './index.vanilla.css'
import { MunchedTree } from './store'

interface Props {
  dateTree: MunchedTree
  year: number
  employeeTimeoffPoliciesFromLeavesData: EmployeeTimeoffPoliciesFromLeavesQuery | null
}

const YearlyCalendar = ({ dateTree, year, employeeTimeoffPoliciesFromLeavesData }: Props) => {
  return (
    <ul className={styles.months}>
      {getMonthsOfYear().map((monthName: string, i: number) => (
        <Month
          dateTree={dateTree}
          year={year}
          month={i}
          monthName={monthName}
          key={`month_${i}`}
          employeeTimeoffPoliciesFromLeavesData={employeeTimeoffPoliciesFromLeavesData}
        />
      ))}
    </ul>
  )
}

export default observer(YearlyCalendar)
